















































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import RegexValidators from '@/shared/regex-validators';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwForm, SwFormRow, SwFormRowError } from '@libs-uuif/shared/sw-form';
import { Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { RenewalContactResponseType } from '../types';

const cssPrefix = 'security-contact';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    fname: { required },
    lname: { required },
    email: { required },
  },
})
export default class SecurityContact extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle: string = '';
  fname: string = '';
  lname: string = '';
  email: string = '';
  emailValidator = new RegExp(RegexValidators.email);
  duplicateSecurityInfo: boolean = false;
  @Prop({ required: true })
  securityRows: any;
  @Prop({ required: true })
  emailAddress: string;
  created() {}
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.duplicateSecurityInfo = false;
    this.$v.$touch();
    if (!this.$v.$invalid) {
      if (
        this.securityRows.filter(
          (item: any) => JSON.stringify(item.emailAddress) === JSON.stringify(this.email),
        ).length <= 0
      ) {
        this.$store.commit('startLoading');
        const request = {
          source: 'SC',
          renewalcontact: {
            firstName: this.fname,
            lastName: this.lname,
            emailAddress: this.email,
            contactId: '',
          },
          adminEmail: this.emailAddress,
        };
        this.$store
          .dispatch('SnbProfileStoreModule/createRenewalContact', request)
          .then((resp: RenewalContactResponseType) => {
            if (resp.operationStatus === 'OK') {
              this.$store.commit('enqueueMessage', {
                infoType: 'success',
                infoMsg: resp.msgDesc,
              });
              request.renewalcontact.contactId = resp.content.renewalContactID;
              this.$emit('success', request);
            } else {
              this.$emit('failed', resp);
            }
          });
      } else {
        this.duplicateSecurityInfo = true;
      }
    }
  }

  cancel() {
    this.$emit('close-modal');
  }
}
